import { Center } from "@chakra-ui/react";
import { GetNews } from "api/GetNews";
import LoaderSpinner from "components/UIComponents/LoaderSpinner";
import PaginatedItems from "pages/MainPage/NewsPagePaginated";
import { useEffect, useState } from "react";
import { sortNewsByLatest } from "utils/news/sortNewsByLatest";

const NewsPage = () => {
  const [news, setNews] = useState([]);

  useEffect(() => {
    if (!news.length) {
      GetNews().then(({ data }) => {
        const sortednews = sortNewsByLatest(data.data.articles);

        setNews(sortednews);
      });
    }
  }, [news.length]);

  return (
    <div>
      {news.length ? (
        <PaginatedItems itemsPerPage={6} items={news} />
      ) : (
        <Center>
          <LoaderSpinner />
        </Center>
      )}
    </div>
  );
};

export default NewsPage;
